import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
  useTheme,
} from "@mui/material";
import {
  confirmButtonStyles,
  dialogActionsStyles,
  dialogContentStyles,
  dialogPaperStyles,
  dialogTitleStyles,
  getContentTypographyStyles,
  getTitleTypographyStyles,
  titleBoxStyles,
} from "./ConfirmDialog.styles";
import {
  DEFAULT_CONFIRM_BUTTON_TEXT,
  DEFAULT_MESSAGE,
  DEFAULT_TITLE,
} from "../utils/consts";

export interface ConfirmDialogProps {
  open: boolean;
  onClose: () => void;
  redirectUrl?: string | null;
  onConfirm?: () => void;
  title?: string;
  message?: string;
  confirmButtonText?: string;
  titleId?: string;
}

export const ConfirmDialog = ({
  open,
  onClose,
  redirectUrl = null,
  onConfirm,
  title = DEFAULT_TITLE,
  message = DEFAULT_MESSAGE,
  confirmButtonText = DEFAULT_CONFIRM_BUTTON_TEXT,
  titleId = "unregistered-user-dialog-title",
}: ConfirmDialogProps) => {
  const theme = useTheme();

  const handleConfirm = () => {
    onClose();
    if (redirectUrl) {
      globalThis.window.location.href = redirectUrl;
    } else {
      onConfirm?.();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleConfirm}
      aria-labelledby={titleId}
      slotProps={{
        paper: {
          sx: dialogPaperStyles,
        },
      }}
    >
      <DialogTitle id={titleId} sx={dialogTitleStyles}>
        <Box sx={titleBoxStyles}>
          <Typography
            variant="h6"
            component="span"
            sx={getTitleTypographyStyles(theme)}
          >
            {title}
          </Typography>
        </Box>
      </DialogTitle>
      <DialogContent sx={dialogContentStyles}>
        <Typography sx={getContentTypographyStyles(theme)}>{message}</Typography>
      </DialogContent>
      <DialogActions sx={dialogActionsStyles}>
        <Button
          onClick={handleConfirm}
          variant="contained"
          sx={confirmButtonStyles}
        >
          {confirmButtonText}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmDialog;
